module.exports = __webpack_public_path__ + "static/media/no-poets-dont-own-words.99e6f88f.txt";